export var FORBIDDEN_CYRILLIC_LETTERS = /^[^а-яА-ЯЁё]+$/iu;
export var NO_WHITESPACE = /^[^\s]+$/iu;
export var ONLY_WHITESPACE = /^\s+$/gi;
